import _ from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classes from "./InsightCountPopover.scss";
import { graphql, compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import { getAssessmentsQuery } from "UnitPlans/modules/UnitPlanQuery";
import { getAssessmentsFromCache } from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import { Popover, ArrowContainer } from "@toddle-edu/react-tiny-popover";
import {
  colors,
  PLACEHOLDER_SQUARE_IMAGE_COUNT,
  PLACEHOLDER_SQUARE_IMAGE,
} from "Constants";
import { gotoAssessmentDetails } from "Assessments/modules/AssessmentModule";
import { CARD_TYPES } from "AppComponents/InsightCountInfo/utils";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";
import { useFocusTrap } from "Hooks";
class InsightCountPopover extends PureComponent {
  constructor(props) {
    super(props);
    this.listContainerRef = React.createRef();
  }

  render() {
    const {
      showLEPopover,
      leAssessmentsData,
      selectedUnitId,
      onClosePopover,
      insightCountRef,
      gotoAssessmentDetails,
      isLoading,
      generateCard,
      t,
      isViewOnly,
      isCurriculumPYP,
      isPYPAssessmentEnabled,
      getCurrentAssessmentTypes,
      containerRef,
    } = this.props;

    const currentAssessmentTypes = getCurrentAssessmentTypes();

    const goToAssessment = ({ id }) => {
      gotoAssessmentDetails({
        id,
        isOpenInNewTab: true,
        mode: "view",
      });
    };

    const handleKeyDown = e => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClosePopover();
      }
    };

    return (
      <Popover
        isOpen={showLEPopover}
        align={"center"}
        positions={["right"]}
        reposition={true}
        onClickOutside={() => {
          onClosePopover();
        }}
        containerStyle={{ zIndex: 1500 }}
        padding={40}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={colors.white}
            arrowSize={10}
            className="popover-arrow-container"
            arrowClassName="popover-arrow"
          >
            <div
              className={classes.lePopUpContainer}
              ref={containerRef}
              onKeyDown={handleKeyDown}
            >
              <div className={classes.heading}>
                {/* we only have assessments in PYP on feature flag */}
                {isCurriculumPYP && !isPYPAssessmentEnabled
                  ? t("common:associated_units_learning_experiences")
                  : t("common:associated_units_assessments_popover_heading")}
              </div>
              {isLoading ? (
                <Loading />
              ) : (
                <div
                  className={classes.assessmentContainer}
                  ref={this.listContainerRef}
                >
                  <KeyboardNavigableList
                    listContainerRef={this.listContainerRef}
                  >
                    {_.map(leAssessmentsData, (node, index) => {
                      const id = _.get(node, "id", 0);
                      const title = _.get(node, "title.value", "Untitled");
                      const imageUrl =
                        _.get(node, "image.value", null) ||
                        PLACEHOLDER_SQUARE_IMAGE[
                          id % PLACEHOLDER_SQUARE_IMAGE_COUNT
                        ];
                      const type = _.get(node, "assessmentType.value", "");
                      const typeLabel = _.get(
                        currentAssessmentTypes[type],
                        "label",
                        ""
                      );

                      return generateCard({
                        id,
                        unitPlanId: id,
                        index,
                        imageUrl,
                        title,
                        subTitle: typeLabel,
                        onClickOpenLinkSvg: isViewOnly
                          ? _.noop
                          : () => {
                              goToAssessment({ id });
                            },
                        cardType: CARD_TYPES.LE_POPOVER,
                      });
                    })}
                  </KeyboardNavigableList>
                </div>
              )}
            </div>
          </ArrowContainer>
        )}
        childrenRef={{ current: insightCountRef[selectedUnitId] }}
        isChildrenRefPassed={true}
      ></Popover>
    );
  }
}

function withRefWrapper(WrappedComponent) {
  return function Wrapper(props) {
    const { showLEPopover } = props;
    const containerRef = useFocusTrap({ isActive: showLEPopover });

    return <WrappedComponent {...props} containerRef={containerRef} />;
  };
}

const mapActionCreatorsToProps = {
  gotoAssessmentDetails,
  getCurrentAssessmentTypes,
};

export default compose(
  connect(null, mapActionCreatorsToProps),
  I18nHOC({ resource: ["common", "planningInsights"] }),
  graphql(getAssessmentsQuery, {
    name: "getAssessments",
    options: ({ leAssessmentIds }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: leAssessmentIds,
      },
    }),
    props({ getAssessments, ownProps: { leAssessmentIds } }) {
      const data = getAssessmentsFromCache({
        ids: leAssessmentIds,
      });

      return {
        leAssessmentsData: data,
        isData: !_.isEmpty(data),
        isLoading:
          getAssessments["networkStatus"] == 1 ||
          getAssessments["networkStatus"] == 2,
      };
    },
  }),
  withRefWrapper
)(InsightCountPopover);

InsightCountPopover.defaultProps = {
  isViewOnly: false,
};
